
import { useState, useEffect } from "react";
import { guideContent } from "../data/guideContent";
import { GuideSection } from "../types/guideTypes";

export const useGuideContent = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeSection, setActiveSection] = useState("getting-started");
  const [expandedSections, setExpandedSections] = useState<string[]>(["getting-started"]);

  const filteredContent = searchQuery
    ? guideContent.filter(section =>
        section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        section.content.some(text => 
          text.toLowerCase().includes(searchQuery.toLowerCase())) ||
        section.subsections?.some(sub =>
          sub.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          sub.content.some(text =>
            text.toLowerCase().includes(searchQuery.toLowerCase()))
        )
      )
    : guideContent;

  useEffect(() => {
    if (filteredContent.length === 1) {
      setActiveSection(filteredContent[0].id);
      setExpandedSections([filteredContent[0].id]);
    }
  }, [searchQuery, filteredContent]);

  return {
    searchQuery,
    setSearchQuery,
    activeSection,
    setActiveSection,
    expandedSections,
    setExpandedSections,
    filteredContent
  };
};
